export const AppLoader = ({ label = "Loading...", variant = "section" }) => (
  <div
    className={`app-loader app-loader--${variant}`}
    role="status"
    aria-live="polite"
  >
    <span className="app-loader__spinner" aria-hidden="true" />
    <span className="app-loader__label">{label}</span>
  </div>
);

export const InlineLoader = ({ label = "Loading..." }) => (
  <span className="inline-loader" role="status" aria-live="polite">
    <span className="inline-loader__spinner" aria-hidden="true" />
    <span>{label}</span>
  </span>
);

export const ButtonLoader = ({ label = "Loading..." }) => (
  <span className="button-loader" role="status" aria-live="polite">
    <span className="button-loader__spinner" aria-hidden="true" />
    <span>{label}</span>
  </span>
);
